import { useState } from "react"
import { Descuento } from "../ModalDescuentos.type"
import { PAYMENT_METHODS } from "src/constants/payments"
interface State extends Descuento {
    visible: boolean
}

const metodos_sin_descuento = [PAYMENT_METHODS.consumoInterno.value, PAYMENT_METHODS.cortesia.value]

export function useStateDescuentos() {
    const [descuento, setDescuento] = useState<State>({ descuento_id: "", total: 0, nombre: "", visible: false })

    return {
        descuento,
        setDescuento,
        metodos_sin_descuento
    }
}